module.exports = __webpack_public_path__ + "static/img/feature_3.3ffdd1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/feature_3.png
// module id = D4Z4
// module chunks = 0